import { clearCustomerInformationFromLocalStorage } from "../clearCustomerDataInLocalStorage/clearCustomerDataInLocalStorage";

const translatedOrder = {
  es: "solicitar",
  it: "ordine",
  pt: "encomenda",
  da: "bestilling",
  de: "bestellung",
  en: "order",
  fr: "commande",
  nl: "bestelling",
  no: "bestilling",
  sv: "bestaellning",
  cs: "objednavka",
  fi: "tilaus",
  pl: "zamowienie",
};

export const logOutCustomer = () => {
  return (dispatch, getState, { api }) => {
    return api.clearCustomerData("CUSTOMER_REGISTRANT").then(
      async (data) => {
        if (data) {
          clearCustomerInformationFromLocalStorage();
          const { locale } = window.onecomConfig;

          // Log out and show Customer form (new customer)
          window.location.href = `/admin/logout?redirectUrl=/${locale}/${translatedOrder[locale]}?page=customer.do`;

          return {
            wasSuccessful: true,
          };
        } else {
          return { wasSuccessful: false };
        }
      },
      (err) => {
        return { wasSuccessful: false };
      },
    );
  };
};
